export const colors = {
  navy: "#1a2744",
  navyLight: "#2C3E6B",
  slate: "#3D4F6F",
  gold: "#C5912B",
  goldDark: "#996e00",
  goldLight: "#E8B84B",
  goldPale: "#FBF4E4",
  cream: "#FAFAF7",
  white: "#FFFFFF",
  black: "#000000",
  darkGray: "#424242",
  lightGray: "#eeeeee",
  border: "#9aa2b4",
  borderLight: "#E8EBF0",
  text: "#1B2A4A",
  textMuted: "#5b6478",
  textLight: "#8B97AD",
  sectionBg: "#F4F5F8",
  infoBg: "#E8F1FA",
  success: "#2D8654",
  successBg: "#E8F5EE",
  error: "#a11002",
  errorBg: "#FDEDEB",
  warning: "#ae7217",
  warningBg: "#FFF7E6"
};
